import { createReducer } from 'redux-act'
import u from 'updeep'

import { receive, receivePaymentData } from 'actions/cellars'

const initialState = {}

export default createReducer({
  [receive]: (state, { id, locale, cellar }) => {
    return u({ [id]: { [locale]: cellar }, cellarId: id, cellarLocale: locale }, state)
  },
  [receivePaymentData]: (state, { id, data }) => {
    return u({ [id]: { paymentData: data } }, state)
  },
}, initialState)
